<template>
  <SearchYearName :title="'Corpos Sociais'" :minYear="1954" :directory="'corpos_sociais'" />
</template>

<script>
import SearchYearName from '@/components/SearchYearName.vue';

export default {
  components: {
    SearchYearName
  }
};
</script>

<style>
</style>
